// Each title becomes 3 products (ebook / audiobook / premium), grouped by `family`.
const TITLES = [
  {
    family: "relacje",
    name: "Jak budować relację, która działa",
    subtitle: "Plan od pierwszych rozmów do bliskości",
    description: "Kompletny przewodnik budowania silnych relacji",
    benefits: ["Mechanizmy budowania atrakcji", "Gotowe schematy rozmów"],
    pages: 164,
    audio_duration: "2 godz 44 min",
    audio_key: "AudioBook_Jak_budować_relację.mp3",
    cover: "/covers/relacje_ebook.png",
    cover_audio: "/covers/relacje_audio.png",
    cover_premium: "/covers/relacje_premium.png",
  },
  {
    family: "manipulacja",
    name: "50 zasad manipulacji",
    subtitle: "Kompletny przewodnik po psychologii wpływu",
    description: "Poznaj zasady psychologii wpływu stosowane w realnych sytuacjach",
    benefits: ["Psychologia wpływu w praktyce", "Zasady stosowane w realnych sytuacjach"],
    pages: 224,
    audio_duration: "3 godz 34 min",
    audio_key: "AudioBook_50_zasad_manipulacji.mp3",
    cover: "/covers/manipulacja_ebook.png",
    cover_audio: "/covers/manipulacja_audio.png",
    cover_premium: "/covers/manipulacja_premium.png",
  },
  {
    family: "wplyw",
    name: "Zakazana sztuka wpływu",
    subtitle: "Kompletny przewodnik po tajnikach manipulacji i perswazji",
    description: "Zaawansowane techniki perswazji i świadoma kontrola rozmowy",
    benefits: ["Zaawansowane techniki perswazji", "Świadoma kontrola dynamiki rozmowy"],
    pages: 78,
    audio_duration: "2 godz 25 min",
    audio_key: "AudioBook_Zakazana_sztuka_wpływu.mp3",
    cover: "/covers/wplyw_ebook.png",
    cover_audio: "/covers/wplyw_audio.png",
    cover_premium: "/covers/wplyw_premium.png",
  },
  {
    family: "pieniadze",
    name: "Psychologia pieniądza",
    subtitle: "Krok po kroku od blokad do mądrych wyborów",
    description: "Mechanizmy decyzji finansowych i mądrzejsze wybory na co dzień",
    benefits: ["Mechanizmy decyzji finansowych", "Mądrzejsze wybory na co dzień"],
    pages: 100,
    audio_duration: "2 godz 30 min",
    audio_key: "AudioBook_Psychologia_pieniądza.mp3",
    cover: "/covers/pieniadze_ebook.png",
    cover_audio: "/covers/pieniadze_audio.png",
    cover_premium: "/covers/pieniadze_premium.png",
  },
  {
    family: "testosteron",
    name: "Testosteron pod kontrolą",
    subtitle: "21-dniowy reset stylu życia, który działa",
    description: "21-dniowy reset energii, koncentracji i stylu życia",
    benefits: ["Reset energii i koncentracji", "Protokół do wdrożenia w 21 dni"],
    pages: 90,
    audio_duration: "2 godz 54 min",
    audio_key: "AudioBook_Testosteron_pod_kontrolą.mp3",
    cover: "/covers/testosteron_ebook.png",
    cover_audio: "/covers/testosteron_audio.png",
    cover_premium: "/covers/testosteron_premium.png",
  },
];

const SINGLES = [];
TITLES.forEach((t, i) => {
  const base = {
    family: t.family, subtitle: t.subtitle, description: t.description,
    short_description: t.description, benefits: t.benefits,
    is_on_sale: true, is_bundle: false, is_active: true, bundle_items: [],
  };
  SINGLES.push({
    ...base, id: `${t.family}-ebook`, product_type: "ebook", name: t.name,
    regular_price: 49, sale_price: 49, cover_image: t.cover, badge: "E-BOOK",
    pages: t.pages, order: i * 3 + 1,
  });
  SINGLES.push({
    ...base, id: `${t.family}-audio`, product_type: "audiobook", name: `${t.name} — Audiobook`,
    regular_price: 59, sale_price: 59, cover_image: t.cover_audio, badge: "AUDIOBOOK",
    audio_key: t.audio_key, audio_duration: t.audio_duration, order: i * 3 + 2,
  });
  SINGLES.push({
    ...base, id: `${t.family}-premium`, product_type: "premium", name: `${t.name} — Premium`,
    regular_price: 79, sale_price: 69, cover_image: t.cover_premium, badge: "PREMIUM",
    pages: t.pages, audio_key: t.audio_key, audio_duration: t.audio_duration, order: i * 3 + 3,
  });
});

// Pack family — 3 options (ebooks only / audio only / VIP all-in)
const PACK_META = {
  description: "Najlepszy wybór jeśli chcesz pracować nad wszystkimi obszarami jednocześnie",
  benefits: ["Kompletny system zmiany", "Największa wartość w pakiecie"],
  pages: 656, audio_duration: "14 godz 7 min",
  is_on_sale: true, is_bundle: true, is_active: true, family: "pakiet",
};
const PACKS = [
  { ...PACK_META, id: "pakiet-ebooks", product_type: "ebook", name: "Kompletny pakiet 5 e-booków",
    subtitle: "5 e-booków w jednym pakiecie",
    regular_price: 197, sale_price: 169, cover_image: "/covers/pakiet_ebook.png", badge: "PAKIET 5 E-BOOKÓW", order: 100 },
  { ...PACK_META, id: "pakiet-audio", product_type: "audiobook", name: "Kompletny pakiet 5 audiobooków",
    subtitle: "5 audiobooków w jednym pakiecie",
    regular_price: 237, sale_price: 199, cover_image: "/covers/pakiet_audio.png", badge: "PAKIET 5 AUDIO", order: 101 },
  { ...PACK_META, id: "pakiet-vip", product_type: "premium", name: "Kompletny pakiet 5 książek",
    subtitle: "5 e-booków + 5 audiobooków w jednym",
    regular_price: 399, sale_price: 249, cover_image: "/covers/pakiet_premium.png", badge: "🔥 VIP PAKIET", order: 102 },
];

const STATIC_PRODUCTS = [...SINGLES, ...PACKS];

export default STATIC_PRODUCTS;
